import ThemeList from '../styles/themes/themeList';

const DEFAULT_THEME = ThemeList[0][1];

function themeSelector({ producerId }: {producerId: number}) {
  const theme = ThemeList.find((theme) => Number(Object.keys(theme)) === producerId);
  return theme ? { ...DEFAULT_THEME, ...Object.values(theme)[0] } : DEFAULT_THEME;
}

export default themeSelector;
